export enum ProjectType {
  Other = 0,
  NewBuilding = 1,
  Renovation = 2,
  Service = 3,
  MasterProject = 4,
}
